import { render, staticRenderFns } from "./modelInfo.vue?vue&type=template&id=7d4ecf59&lang=pug"
import script from "./modelInfo.vue?vue&type=script&lang=js"
export * from "./modelInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports